// @flow
import React from "react";
import styles from "./index.module.css";
const technical_error = require("../../images/technical_error.png");
// type Props = {};

const Component500 = props => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.error}>
        <img src={technical_error} width={150} height={220} alt="error" />
      </div>
      <div className={styles.description}>
        Sorry, We can not process your request due to a temporary error, please
        try again after some time
      </div>
    </div>
  );
};

export default Component500;
